import { useNavigate } from 'react-router-dom';
import { BookOpen, ArrowRight, Award } from 'lucide-react';

const TAJ_BG = 'https://images.unsplash.com/photo-1734966901559-0f401c2dbd75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxJbmRpYSUyMFRhaiUyME1haGFsJTIwY29sb3JmdWwlMjBpbGx1c3RyYXRpb258ZW58MHx8fHwxNzc2NDk2NDI1fDA&ixlib=rb-4.1.0&q=85';

export default function GKHomePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col" style={{ background: 'linear-gradient(180deg, #FF9933 0%, #FF9933 33%, #FFFFFF 33%, #FFFFFF 66%, #138808 66%, #138808 100%)' }}>
      {/* Saffron section */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 relative">
        {/* Ashoka Chakra decorative */}
        <div className="w-28 h-28 sm:w-36 sm:h-36 rounded-full border-[6px] border-white/40 flex items-center justify-center mb-4 animate-spin" style={{ animation: 'spin 30s linear infinite' }}>
          <div className="w-20 h-20 sm:w-28 sm:h-28 rounded-full border-4 border-dashed border-white/30" />
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black text-white drop-shadow-lg text-center tracking-tight">
          India GK Quiz
        </h1>
      </div>

      {/* White section */}
      <div className="flex-1 flex flex-col items-center justify-center px-6">
        <p className="font-body text-base sm:text-lg text-gray-600 text-center max-w-md mb-6 leading-relaxed">
          Test your knowledge about India! 20 questions about our amazing country — national symbols, geography, history, sports & more!
        </p>
        <div className="flex items-center gap-3 mb-4">
          <div className="flex items-center gap-1.5 bg-orange-50 text-orange-600 text-xs font-bold px-3 py-1.5 rounded-full">
            <BookOpen className="w-3.5 h-3.5" />
            20 Questions
          </div>
          <div className="flex items-center gap-1.5 bg-green-50 text-green-700 text-xs font-bold px-3 py-1.5 rounded-full">
            <Award className="w-3.5 h-3.5" />
            Earn Stars
          </div>
        </div>
        <button
          data-testid="start-gk-quiz"
          onClick={() => navigate('/gk-quiz/play')}
          className="bg-[#000080] text-white font-black text-xl py-4 px-10 rounded-full border-b-[6px] border-[#000060] active:border-b-0 active:translate-y-[6px] transition-all hover:bg-[#0000a0] flex items-center gap-3 shadow-lg"
        >
          Start Quiz
          <ArrowRight className="w-6 h-6" />
        </button>
      </div>

      {/* Green section */}
      <div className="flex-1 flex flex-col items-center justify-center px-6">
        <div className="flex gap-4">
          <button
            data-testid="gk-back-studio"
            onClick={() => navigate('/')}
            className="text-white/80 font-bold text-sm hover:text-white transition-colors underline"
          >
            Back to Studio
          </button>
        </div>
      </div>
    </div>
  );
}
